import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const LotusMatka = () => {

  const {Info}=useSelector((state)=>state.users);

  const downloadApk = () => {
    const iframe = document.createElement("iframe");
    const url = Info?.download_url || "https://matkafun.org/home/images/Matkafun.apk";
    iframe.src = url;
    iframe.style = "height:1px;width:1px;position:absolute;bottom:0px;";
    document.body.appendChild(iframe);
  }
  

useEffect(() => {
    // Dynamically import the CSS file when the component is mounted
    import('./download.css')
      .then(() => {
        console.log('CSS Loaded!');
      })
      .catch((err) => {
        console.log('Error loading CSS: ', err);
      });

    // Cleanup on unmount (optional)
    return () => {
      // If you need to handle cleanup, remove the dynamically imported CSS here
      // Note: CSS removal requires custom handling (e.g., manipulating the DOM)
      console.log('Component Unmounted');
    };
  }, []);


  return (
    <div>
      <div className="w-full" style={{overflowY: 'hidden'}}>
        <nav className="bg-white fixed top-0 z-50 w-full shadow backdrop-blur backdrop-filter bg-opacity-70">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <a style={{cursor: 'default'}} href="index.html">
                    <img className="block h-12 w-auto" src="home/images/logo_tara.png" alt="Mama 567" />
                  </a>
                </div>
              </div>
              <div className="hidden sm:block sm:ml-6">
                <div className="flex space-x-4">
                  <a className="bg-white text-pink font-weight px-3 py-2 rounded-md text-sm font-medium hover:scale-125 duration-200 hover:text-indigo-700" href="https://matkafun.org">
                    Play Online
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>
        
        <div className="flex flex-col items-center min-h-screen mt-10">
          <section className="flex flex-col w-full text-center header mt-5">
            <div className="relative z-10 margin-top">
              <h2 className="text-3xl md:text-6xl font-bold">
                It's Time For <span className="text-pink"> Mama 567 </span>
              </h2>
              <p className="mt-3 text-xl md:text-3xl">Where you become a master of your own games!</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-1">
              <div><img  style={{maxWidth:'47%',maxHeight:'28%'}} src="home/images/logo_tara.png" className="rounded-full w-96 h-96 mx-auto" alt="girl-image" /></div>
            </div>
          </section>

          <section id="hero" className="w-full h-72 bg-blue pt-4">
            <div className="grid grid-row-3 md:grid-rows-1 max-w-7xl mx-auto px-4 overflow-hidden sm:px-6 lg:px-8">
              <div className="flex justify-center space-x-6">
                <button 
                  className="bounce p-3 rounded-full w-48 md:w-72 text-white border-white border-2 shadow"
                  style={{background: 'linear-gradient(45deg, #F08 0%, #ffdf5d 100%)', marginTop: '20px'}}
                  onClick={downloadApk}
                >
                  <i className="fa fa-hand-o-right font-16"></i> Download Now
                </button>
              </div>
              <div className="mt-8 text-center text-base">
                <h3 className="text-2xl text-gray-800"><strong style={{color: '#ffff'}}> You can Play Online also Hurry up !!!! </strong></h3>
              </div>
              <div className="mt-6 flex justify-center space-x-6">
                <a className="bg-green-600 p-3 rounded-full text-white w-48 border-white border-2 shadow text-center" href="https://matkafun.org" target="_blank">
                  <i className="fa fa-comment" aria-hidden="true"></i> Play Online 
                </a>
              </div>
            </div>
          </section>

          <section id="result" className="section position-relative w-full">
            <div className="container">
              <div className="grid grid-rows-1">
                <div className="grid grid-cols-1 text-center">
                  <h2 className="section-title">Why play game on Mama 567?</h2>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="card px-3 py-5 border-0 rounded-lg shadow text-center card-border-bottom mt-3">
                    <i className="fa fa-money icon-lg icon-bg-square mb-5 icon-primary font-style"></i>
                    <h4 className="mb-3" style={{fontSize: '18px'}}>Instant Deposit And Withdraw</h4>
                  </div>
                  <div className="card px-3 py-5 border-0 rounded-lg shadow text-center card-border-bottom mt-3">
                    <i className="fa fa-star-half-o icon-lg icon-bg-square mb-5 icon-primary font-style"></i>
                    <h4 className="mb-3" style={{fontSize: '18px'}}>4.5 Star Ratings</h4>
                  </div>
                  <div className="card px-3 py-5 border-0 rounded-lg shadow text-center card-border-bottom mt-3">
                    <i className="fa fa-shield icon-lg icon-bg-square mb-5 icon-primary font-style"></i>
                    <h4 className="mb-3" style={{fontSize: '18px'}}>Trusted ICON</h4>
                  </div>
                  <div className="card px-3 py-5 border-0 rounded-lg shadow text-center card-border-bottom mt-3">
                    <i className="fa fa-phone icon-lg icon-bg-square mb-5 icon-primary font-style"></i>
                    <h4 className="mb-3" style={{fontSize: '18px'}}>Customer Support</h4>
                  </div>
                </div>
              </div>
            </div>
            <img src="images/dot/dot-1.png" className="img-fluid feature-bg-shape-1" alt="background-dots" />
            <img src="images/shape/shape-bg.png" className="img-fluid feature-bg-shape-2" alt="background-shape" />
          </section>

          {/* More sections... */}

        </div>

        <footer className="p-4 sm:p-6 dark:bg-gray-900 footer-sec bg-secondary">
          <div className="sm:flex sm:items-center sm:justify-between text-center">
            <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
              <p className="mt-8 text-center text-base">Copyright © 024 Mama 567 | All rights reserved</p>
            </span>
            <div className="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
              {/* Social media links can go here */}
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default LotusMatka;
